import { persis as restClient } from "~/persis-system/config/restClient";
import moment from "moment";
let initTranslationData = undefined;

// Übersetzungen für Vuetify Komponenten
const translateVuetifyComponents = data => {
  return {
    $vuetify: {
      badge: data["Vuetify.Badge"],
      close: data["Vuetify.Close"],
      dataIterator: translateDataIterator(data),
      dataTable: translateDataTable(data),
      dataFooter: translateDataFooter(data),
      datePicker: {
        itemsSelected: data["Vuetify.DatePicker.ItemsSelected"]
      },
      noDataText: data["Vuetify.NoDataText"],
      carousel: translateCarousel(data),
      calendar: {
        moreEvents: data["Vuetify.Calendar.MoreEvents"]
      },
      fileInput: translateFileInput(data),
      timePicker: {
        am: "AM",
        pm: "PM"
      }
    }
  };
};

const translateDataIterator = data => ({
  noResultsText: data["Vuetify.DataIterator.NoResultsText"],
  loadingText: data["Vuetify.DataIterator.LoadingText"]
});

const translateDataTable = data => ({
  itemsPerPageText: data["Vuetify.DataTable.ItemsPerPageText"],
  ariaLabel: translateAriaLabel(data),
  sortBy: data["Vuetify.DataTable.SortBy"]
});

const translateAriaLabel = data => ({
  sortDescending: data["Vuetify.DataTable.AriaLabel.SortDescending"],
  sortAscending: data["Vuetify.DataTable.AriaLabel.SortAscending"],
  sortNone: data["Vuetify.DataTable.AriaLabel.SortNone"],
  activateNone: data["Vuetify.DataTable.AriaLabel.ActivateNone"],
  activateDescending: data["Vuetify.DataTable.AriaLabel.ActivateDescending"],
  activateAscending: data["Vuetify.DataTable.AriaLabel.ActivateAscending"]
});

const translateDataFooter = data => ({
  itemsPerPageText: data["Vuetify.DataFooter.ItemsPerPageText"],
  itemsPerPageAll: data["Vuetify.DataFooter.ItemsPerPageAll"],
  nextPage: data["Vuetify.DataFooter.NextPage"],
  prevPage: data["Vuetify.DataFooter.PrevPage"],
  firstPage: data["Vuetify.DataFooter.FirstPage"],
  lastPage: data["Vuetify.DataFooter.LastPage"],
  pageText: data["Vuetify.DataFooter.PageText"]
});

const translateCarousel = data => ({
  prev: data["Vuetify.Carousel.Prev"],
  next: data["Vuetify.Carousel.Next"],
  ariaLabel: {
    delimiter: data["Vuetify.Carousel.AriaLabel.Delimiter"]
  }
});

const translateFileInput = data => ({
  counter: data["Vuetify.FileInput.Counter"],
  counterSize: data["Vuetify.FileInput.CounterSize"]
});

export const loadTranslations = () =>
  restClient
    .translations()
    .then(({ data }) => {
      initTranslationData = data;
    })
    .catch(error => {
      window.atomlog("login restClient translationEndPoint: " + error, "error");
    });

const loadI18nSettings = app => {
  restClient
    .i18nSettings()
    .then(({ data }) => {
      app.$i18n.mergeLocaleMessage(app.$i18n.locale, { i18nSettings: data });
    })
    .catch(error => {
      window.atomlog(
        "login restClient i18nSettingsEndPoint: " + error,
        "error"
      );
    });
};

export const initializeTranslations = app => {
  app.$i18n.setLocaleMessage(app.$i18n.locale, initTranslationData);
  app.$i18n.mergeLocaleMessage(
    app.$i18n.locale,
    translateVuetifyComponents(initTranslationData)
  );
  loadI18nSettings(app);
  moment.locale(app.$i18n.locale);
  initTranslationData = undefined;
};
